import { Card, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { User } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';
import { useAuth } from '@/context/AuthContext';

import { API } from '@/lib/apiBase';

export const AboutMeCard = ({ settings, updateField, imgVersion, onPhotoUploaded }) => {
  const { t } = useLanguage();
  const { getAuthHeaders } = useAuth();

  const handlePhotoUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const fd = new FormData();
    fd.append('file', file);
    try {
      const res = await fetch(`${API}/admin/site-settings/about-photo`, {
        method: 'POST',
        headers: getAuthHeaders(),
        credentials: 'include',
        body: fd,
      });
      if (res.ok) {
        updateField('has_about_photo', true);
        onPhotoUploaded?.();
        toast.success(t('common.success'));
      } else {
        toast.error(t('common.error'));
      }
    } catch (err) {
      toast.error(t('common.error'));
    }
  };

  return (
    <Card className="bg-card border-border">
      <CardContent className="p-6">
        <div className="flex items-center gap-2 mb-6">
          <User className="w-5 h-5 text-primary" />
          <h2 className="text-lg font-bold">{t('siteSettings.aboutMe')}</h2>
        </div>

        <div className="space-y-4">
          <div>
            <Label className="text-sm">{t('siteSettings.aboutPhoto')}</Label>
            <div className="flex items-center gap-4 mt-2">
              {settings.has_about_photo && (
                <img
                  src={`${API}/site-settings/about-photo?${imgVersion}`}
                  alt="About"
                  className="w-20 h-20 rounded-lg object-cover border border-border"
                />
              )}
              <div>
                <Input
                  type="file" accept="image/*"
                  onChange={handlePhotoUpload}
                  className="bg-secondary border-border max-w-xs"
                  data-testid="about-photo-upload"
                />
                <p className="text-xs text-muted-foreground mt-1">{t('siteSettings.aboutPhotoHint')}</p>
              </div>
            </div>
          </div>

          <div>
            <Label className="text-sm">{t('siteSettings.aboutBio')}</Label>
            <Textarea
              value={settings.about_bio || ''}
              onChange={(e) => updateField('about_bio', e.target.value)}
              rows={6}
              placeholder={t('siteSettings.aboutBioPlaceholder')}
              className="bg-secondary border-border mt-1"
              data-testid="about-bio-input"
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
